import { useEffect } from "react"
import PropTypes from "prop-types"

function ActivateAccount({ token, account, activateUser }) {
  useEffect(() => {
    if (token && account) {
      activateUser(token)
    }
  }, [token, account, activateUser])

  return null
}

ActivateAccount.propTypes = {
  account: PropTypes.string,
  token: PropTypes.string,
  activateUser: PropTypes.func.isRequired,
}

export default ActivateAccount
